<script lang="ts">
  // import LogoComp from "$components/circle-logo/index.svelte";
  import NavMenu from "../_components/nav-menu.svelte";
  import Cart from "$components/cart/cart.svelte";
  import NavItem from "$components/navbar/nav-item.svelte";
  import TrustBy from "./trust-by.svelte";
  import LinkComp from "$components/link.svelte";
  import { utils } from "$lib/utils";
  import { toBreadCrumb } from "$lib/utils/ldjson";
  import type { IEventTBC } from "types/backend/models/event.entity";
  import type { IAttributes } from "../+page.server";
  import { isNavOpen, setNavIsOpen } from "$lib/store/auth-context";

  export let tbc: IEventTBC;
  export let title: string;
  export let season: string = "";
  export let locale: string;
  export let datetime: string;
  export let venueTitle: string;
  export let performers: { slug: string; title: string; attributes: IAttributes }[];
  export let subCategory: { title: string };
  export let paths: { name: string; url: string }[] = [];
  export let played = false;
  export let nav: NavItem[];

  $: perf1 = performers[0] || { title: "TBC", slug: "" };
  $: perf2 = performers[1] || { title: "TBC", slug: "" };
  // function makeGradient() {
  //   let team1 = performers[0]?.attributes?.colour || "#f2bfdb";
  //   let team2 = performers[1]?.attributes?.colour || "#99aee8";
  //   const obj1 = utils.hexToRgb(team1);
  //   const obj2 = utils.hexToRgb(team2);
  //   const rgba1 = `rgba(${obj1.r}, ${obj1.g},${obj1.b}, 0.1)`;
  //   const rgba2 = `rgba(${obj2.r}, ${obj2.g},${obj2.b}, 0.1)`;
  //   return `background: linear-gradient(to right, ${rgba1}, ${rgba2});`;
  // }

  function openNav(ev: Event) {
    ev.stopImmediatePropagation();
    setNavIsOpen(!$isNavOpen);
  }
</script>

<svelte:head>
  {@html toBreadCrumb(paths)}
</svelte:head>

<!-- Uncomment if want to reinstate the background with the teams colour -->
<!-- <div class="breadcrumb-wrapper" style={makeGradient()}> -->
<div class="breadcrumb-wrapper">
  <div class="breadcrumb">
    <!-- <div class="logos grid">
      <div class="logo"><LogoComp colour={team1Colour} /></div>
      <div class="logo"><LogoComp colour={team2Colour} index={1} /></div>
    </div> -->
    <div class="logo-link">
      <LinkComp href={"/"}>
        <span class="icon" />
      </LinkComp>
      <div>
        <i />
        <div class="nav-wrapper">
          <NavMenu {nav} />
        </div>
      </div>
    </div>
    <div class="title">
      <!-- <h1 class="sf-600">{title} <span>Tickets</span></h1> -->
      <h1 class="pf-800">
        <LinkComp href={`/teams${perf1.slug}`}>{perf1.title}</LinkComp>
        <span>v</span>
        <LinkComp href={`/teams${perf2.slug}`}>{perf2.title}</LinkComp>
        <span>Tickets</span>
      </h1>
      <p class="pf-500 event-info">
        <span class="pf-500">
          {utils.getDateAndTime(datetime, locale, 20, tbc)},
          {utils.getTZTime(datetime, tbc)} | {venueTitle}, {subCategory?.title}
          {season}
        </span>
        {#if played}
          <b>(This game has been played)</b>
        {/if}
      </p>
    </div>
    <div class="mini-nav">
      <Cart />
      <button class="burger" on:click={openNav} />
    </div>
    <div class="trust-wrapper">
      <TrustBy />
    </div>
  </div>
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .mini-nav {
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 30px;
    gap: 0.5em;
    .burger {
      display: block;
      width: 2em;
      height: 2em;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-color: unset;
      border: none;
      background-image: url("../_assets/burger.svg");
    }
    @include desktop {
      display: none;
    }
  }

  .breadcrumb-wrapper {
    padding: 0.6em 1.5em;
    background: #f8f8f8;
    border-bottom: 1px solid #d8d8d8;
    @include desktop {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1.4em 3.1em;
    }

    .breadcrumb {
      display: grid;
      text-align: center;
      grid-template-columns: 80% 20%;
      @include desktop {
        width: 100%;
        grid-template-columns: 15em auto 20em;
        gap: 1em;
        text-align: left;
        align-items: center;
      }
      .logo-link {
        display: none;
        @include desktop {
          display: block;
          height: 32px;
          width: 150px;
          margin: -1em 0 0.5em;
          width: auto;
          height: auto;
          margin: 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          align-items: center;
          gap: 1em;
          div {
            display: block;
            padding: 0;
            position: relative;
            width: 20px;
            height: 13px;
            i {
              display: inline-block;
              width: 7px;
              height: 13px;
              background-image: url("../_assets/arrow-dark.svg");
              background-position: center;
              background-repeat: no-repeat;
              transform: rotate(90deg);
            }
            .nav-wrapper {
              visibility: hidden;
              opacity: 0;
            }
            &:hover {
              i {
                transform: rotate(270deg);
              }
              .nav-wrapper {
                position: relative;
                visibility: visible;
                opacity: 1;
              }
            }
          }
        }
      }

      .title {
        text-align: left;
        h1 {
          color: #3649ce;
          font-size: 1.23em;
          margin-bottom: 0.3em;
          span {
            color: #000;
          }
          @include desktop {
            font-size: 1.5em;
            font-weight: 700;
          }
        }
      }

      // .logos {
      //   grid-template-columns: 1fr 1fr;
      //   margin-bottom: 0.62em;
      //   justify-items: center;
      //   padding: 0em 4em;
      //   @include desktop {
      //     padding: 0em;
      //     gap: 1em;
      //   }
      //   .logo {
      //     width: 3.25em;
      //     height: 3.25em;
      //   }
      // }

      .event-info {
        margin: 0;
        color: #6f6f6f;
        font-size: 12px;
        @include desktop {
          font-size: 16px;
        }
        span {
          display: block;
          line-height: 120%;
          @include desktop {
            display: inline-block;
          }
        }
      }

      .trust-wrapper {
        display: none;
        @include desktop {
          display: block;
        }
      }
    }

    .icon {
      display: block;
      width: 130px;
      background: url("@styles/assets/logo.svg") no-repeat;
      background-size: cover;
      height: 22px;

      @include desktop {
        width: 11.2em;
        height: 1.9em;
        background-size: cover;
      }
    }
  }
</style>
